import React from 'react';
import tinycolor from 'tinycolor2';

type Props = {
  status: string;
  color: string;
};

const MyTaskKanbanStatusCard = ({ status, color }: Props) => {
  const background = tinycolor.mix(color, '#FFFFFF', 60).toHexString();

  return (
    <div
      style={{
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: color,
        backgroundColor: background,
        marginBottom: 8,
        padding: '4px',
      }}
    >
      <b>{status}</b>
    </div>
  );
};

export default MyTaskKanbanStatusCard;
